<template>
  <BaseModal
    :heading="$t('admin.cards.plan.cancel_subscription')"
    small
    @close="$emit('close')"
  >
    <BaseText mb>
      {{ $t('subscription.cancelation_flow.cancelation_options.description') }}
    </BaseText>
    <Flex direction="column">
      <BaseButtonCard
        v-if="isMonthlySubscription"
        :heading="$t('subscription.cancelation_flow.cancelation_options.pause.heading')"
        :description="$t('subscription.cancelation_flow.cancelation_options.pause.description')"
        icon="clock"
        chevron
        @click="() => {
          $emit('select', 'pause');
        }"
        v-test="'cancel-flow-option-pause'"
      />
      <BaseButtonCard
        v-if="isFreePlanOfferEnabled"
        :heading="$t('subscription.cancelation_flow.cancelation_options.try_for_free.heading')"
        :description="$t('subscription.cancelation_flow.cancelation_options.try_for_free.description', brandName())"
        icon="bulb"
        chevron
        @click="() => {
          $emit('select', 'try_for_free');
        }"
        v-test="'cancel-flow-option-try-for-free'"
      />
      <BaseButtonCard
        :heading="$t('subscription.cancelation_flow.cancelation_options.cancel.heading')"
        :description="$t('subscription.cancelation_flow.cancelation_options.cancel.description', brandName())"
        icon="close"
        chevron
        @click="() => {
          $emit('select', 'cancel');
        }"
        v-test="'cancel-flow-option-cancel'"
      />
    </Flex>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { brandName } from '@/helpers/brand-name';
import { useCompanyStore } from '@/stores/company';
import { useTreatwellStore } from '@/stores/treatwell';
import unleash from '@/unleash';

defineEmits(['select', 'close']);

const { company } = useCompanyStore();

const isMonthlySubscription = computed(() => {
  return company.activeSubscription?.billingPeriod === 'monthly';
});

const isFreePlanOfferEnabled = computed(() => {
  const { showTreatwell } = useTreatwellStore();

  return (
    showTreatwell &&
    unleash.isEnabled('CancelSubscriptionFreePlanOffer') &&
    company.activeSubscription?.plan !== 'lite'
  );
});
</script>
